// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__8Kc4b","statusInfo":"styles_statusInfo__X8Vdn","illustration":"styles_illustration__NJKkq"};